module.exports = __webpack_public_path__ + "img/passportNumber.3f9e910f.svg";